<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <!-- Update File -->
      <b-form-group
        label="Update File"
        label-for="update_file"
      >
        <b-form-file
          id="update_file"
          v-model="update_file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BFormFile,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationObserver,
    BFormGroup,
    BForm,
    BFormFile,
  },
  props: {
    projectId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      update_file: null,
      required,
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success && this.update_file) {
          const formData = new FormData()
          formData.append('ProjectId', this.projectId)
          formData.append('UpdateFile', this.update_file)

          useJwt.axiosIns.post('project/UpdateFiles', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {
              if (response.data) {
                if (response.data === 'Ok') {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Success',
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: 'Update completed',
                    },
                  })
                  this.$emit('success')
                } else {
                  this.$emit('error', response.data)
                }
                this.update_file = null
              }
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          this.$emit('error', 'Select a file!')
        }
      })
    },
  },
}
</script>
